import React, { forwardRef } from 'react';
import clsx from 'clsx';
import Icon from './Icon';

const RoundedPlusButton = forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>((props: React.ButtonHTMLAttributes<HTMLButtonElement>, ref) => {
  return (
    <button
      {...props}
      className={clsx(
        props.className,
        'flex h-6 w-6 items-center justify-center rounded-full bg-opacity-white-90 transition-transform hover:scale-110 lg:h-8 lg:w-8 lg:p-1'
      )}
      ref={ref}
    >
      <Icon name="plus" className="h-4 w-4" />
    </button>
  );
});

RoundedPlusButton.displayName = 'RoundedPlusButton';

export default RoundedPlusButton;
